import type { PortfolioSummaryDto } from '../shared/types';

type Health = PortfolioSummaryDto['health'];

export type NotificationItem = {
  kind: 'DRAFT' | 'QUOTE';
  label: string;
  detail: string;
  to: string;
};

export function buildNotificationItems(health: Health): NotificationItem[] {
  const items: NotificationItem[] = [];
  if (health.pendingDrafts > 0) {
    items.push({
      kind: 'DRAFT',
      label: `มีสลิป ${health.pendingDrafts} ใบรอตรวจ`,
      detail: 'ตรวจข้อมูล OCR และยืนยันก่อนบันทึกเข้าพอร์ต',
      to: '/review',
    });
  }
  const quoteIssues = health.staleQuotes + health.missingQuotes;
  if (quoteIssues > 0) {
    items.push({
      kind: 'QUOTE',
      label: `มีราคา ${quoteIssues} รายการที่ควรตรวจ`,
      detail: health.missingQuotes > 0 ? 'บางสินทรัพย์ยังไม่มีราคา หรือข้อมูลราคาเก่า' : 'ข้อมูลราคาบางรายการเกินช่วง freshness',
      to: '/',
    });
  }
  return items;
}
